import React from 'react';
import MaterialTableCustom from '../../../components/MaterialTableCustom';

// parentChildData uses _singleParent
const parentChildData = (row, rows) =>
  rows.find((r) => r.id === row._singleParent);

export default function BomTable({ data }) {
  if (!data) return null;

  const title = 'BOM Preview';

  const formattedColumns = [
    { field: 'partNumber', title: 'PN' },
    { field: 'partType', title: 'Type' },
    { field: 'description', title: 'Description' },
    {
      field: 'bomQty',
      title: 'Qty',
      render: (rowData) => {
        const rowParent = Object.keys(rowData.parents);
        if (rowParent.length) return rowData.parents[rowParent[0]];
        return '';
      },
    },
  ];

  const rowStyle = { fontSize: '13px' };

  // duplicate rows for multiple parents
  const expandChildrenForMultipleParents = (rows) => {
    const newRows = [];
    rows.forEach((row) => {
      const parentIds = Object.keys(row.parents);
      if (parentIds.length === 0) {
        newRows.push({ ...row, _singleParent: null });
      } else {
        parentIds.forEach((pid) => {
          newRows.push({ ...row, _singleParent: pid });
        });
      }
    });
    return newRows;
  };

  // handle search while preserving hierarchy and multiple parents
  const queryData = async (searchText) => {
    if (!searchText) return expandChildrenForMultipleParents(data);

    const lower = searchText.toLowerCase();
    const idMap = new Map(data.map((r) => [r.id, r]));

    // Step 1: find matching rows
    const matched = data.filter((row) =>
      Object.values(row)
        .filter((val) => typeof val === 'string')
        .some((val) => val.toLowerCase().includes(lower))
    );

    // Step 2: recursively add parents and keep multiple parents
    const result = new Map();

    const addRowWithParents = (row, parentId = null) => {
      // duplicate for this parent
      const rowCopy = { ...row, _singleParent: parentId };

      if (!result.has(row.id)) result.set(row.id, []);
      result.get(row.id).push(rowCopy);

      // recursively add parents
      Object.keys(row.parents).forEach((pid) => {

        const parent = idMap.get(pid);
        if (parent && !result.has(pid)) {
          addRowWithParents(parent, null)
        };
      });
    };

    matched.forEach((row) => addRowWithParents(row));

    // flatten result
    const allRows = Array.from(result.values()).flat();

    return expandChildrenForMultipleParents(allRows);
  };

  return (
    <MaterialTableCustom
      title={title}
      data={data}
      columns={formattedColumns}
      rowStyle={rowStyle}
      parentChildData={parentChildData}
      queryData={queryData}
      options={{ search: true, defaultExpanded: true}}
    />
  );
}
